<template>

	<div class="invite-download-page">

		<div class="buttons">
			<div class="item" @click="iosDownload">
				<van-button 
					:icon="require('../../assets/images/icon_ios.png')"
					type="warning"
				>{{ translate('download_ios') }}</van-button>
			</div>
			<div class="item" @click="androidDownload">
				<van-button 
					:icon="require('../../assets/images/icon_android.png')"
					type="primary"
				>{{ translate('download_android') }}</van-button>
			</div>
		</div>

		<!-- <div class="buttons">
			<div style="margin-bottom: 10px">
				<van-image :src="require('@/assets/images/ios-download.png')" @click="iosDownload"></van-image>
			</div>

			<div>
				<van-image :src="require('@/assets/images/android-download.png')" @click="androidDownload"></van-image>
			</div>
		</div> -->

		<van-overlay :show="isWeiXin">
			<div class="wrapper">
				<div class="weixin-browser"></div>
			</div>
		</van-overlay>
	</div>

</template>

<script>
	export default {
		name: 'invite_download',
		data() {
			return {

				resourceURL: this.$axios.defaults.resourceURL,
				
				isWeiXin: false,

			}
		},

		mounted() {
			document.title = this.translate('app_download') 

			var ua = window.navigator.userAgent.toLowerCase();

			//通过正则表达式匹配ua中是否含有MicroMessenger字符串
			if(ua.match(/MicroMessenger/i) == 'micromessenger'){
				this.isWeiXin = true
			} else{
				this.isWeiXin = false
			}
		},
		
		methods: {

			iosDownload(){
				// this.$dialog.alert({
				// 	message: this.translate('application_development'),
				// });
					
				window.location.href= 'https://apps.apple.com/cn/app/%E6%99%BA%E6%98%93%E6%9D%B1%E6%96%B9/id1672164746'
			},
			
			androidDownload() {
				window.location.href= this.$axios.defaults.baseURL + '/download_download/android'			
			},
		},

	}
</script>            